import axios from "axios";
import { buildUrl } from "@/config";

export default {
  getEstablishments() {
    const url = buildUrl("api/v1/establishment");
    console.log("Calling Establishments API:", url);
    return axios.get(url);
  },
};
